import type { ChatMessageData } from '@ps/api/types';

export enum SocketEvent {
  NewMsg = 'private.message',
}

export type SocketEventArgs = {
  [SocketEvent.NewMsg]: ChatMessageData;
};
